import _classCallCheck from "D:\\ReactJs\\kaith-app-frontend-dashboard-master\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\ReactJs\\kaith-app-frontend-dashboard-master\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\ReactJs\\kaith-app-frontend-dashboard-master\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\ReactJs\\kaith-app-frontend-dashboard-master\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\ReactJs\\kaith-app-frontend-dashboard-master\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Transport } from "../transport.js";
import { nextTick } from "./websocket-constructor.js";
import { createPacketDecoderStream, createPacketEncoderStream } from "engine.io-parser";
export var WT =
/*#__PURE__*/
function (_Transport) {
  _inherits(WT, _Transport);

  function WT() {
    _classCallCheck(this, WT);

    return _possibleConstructorReturn(this, _getPrototypeOf(WT).apply(this, arguments));
  }

  _createClass(WT, [{
    key: "doOpen",
    value: function doOpen() {
      var _this = this;

      // @ts-ignore
      if (typeof WebTransport !== "function") {
        return;
      } // @ts-ignore


      this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
      this.transport.closed.then(function () {
        _this.onClose();
      }).catch(function (err) {
        _this.onError("webtransport error", err);
      }); // note: we could have used async/await, but that would require some additional polyfills

      this.transport.ready.then(function () {
        _this.transport.createBidirectionalStream().then(function (stream) {
          var decoderStream = createPacketDecoderStream(Number.MAX_SAFE_INTEGER, _this.socket.binaryType);
          var reader = stream.readable.pipeThrough(decoderStream).getReader();
          var encoderStream = createPacketEncoderStream();
          encoderStream.readable.pipeTo(stream.writable);
          _this.writer = encoderStream.writable.getWriter();

          var read = function read() {
            reader.read().then(function (_ref) {
              var done = _ref.done,
                  value = _ref.value;

              if (done) {
                return;
              }

              _this.onPacket(value);

              read();
            }).catch(function (err) {});
          };

          read();
          var packet = {
            type: "open"
          };

          if (_this.query.sid) {
            packet.data = "{\"sid\":\"".concat(_this.query.sid, "\"}");
          }

          _this.writer.write(packet).then(function () {
            return _this.onOpen();
          });
        });
      });
    }
  }, {
    key: "write",
    value: function write(packets) {
      var _this2 = this;

      this.writable = false;

      var _loop = function _loop(i) {
        var packet = packets[i];
        var lastPacket = i === packets.length - 1;

        _this2.writer.write(packet).then(function () {
          if (lastPacket) {
            nextTick(function () {
              _this2.writable = true;

              _this2.emitReserved("drain");
            }, _this2.setTimeoutFn);
          }
        });
      };

      for (var i = 0; i < packets.length; i++) {
        _loop(i);
      }
    }
  }, {
    key: "doClose",
    value: function doClose() {
      var _a;

      (_a = this.transport) === null || _a === void 0 ? void 0 : _a.close();
    }
  }, {
    key: "name",
    get: function get() {
      return "webtransport";
    }
  }]);

  return WT;
}(Transport);